import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className = '',
  variant = 'primary',
  fullWidth,
  children,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-cream-100';
  const variants = {
    primary: 'bg-gold-500 text-white hover:bg-gold-600 focus:ring-gold-500 shadow-gold-500/30',
    secondary: 'bg-sage-500 text-white hover:bg-sage-400 focus:ring-sage-500 shadow-sage-500/30'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button ref={ref} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-163">
        {children}
      </motion.button>;
});
Button.displayName = 'Button';